import React from 'react';

const variants = {
  primary: 'bg-gradient-to-br from-purple-500 to-purple-700 text-white hover:opacity-90 hover:-translate-y-0.5',
  secondary: 'bg-white text-slate-800 border border-slate-200 hover:bg-slate-50 hover:border-slate-300',
  ghost: 'bg-transparent text-slate-500 hover:bg-slate-100 hover:text-slate-700',
  danger: 'bg-red-500 text-white hover:bg-red-600',
};

export const Button = ({ variant = 'primary', children, icon, className = '', ...props }) => (
  <button
    className={`inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg text-sm font-medium 
      transition-all duration-150 cursor-pointer border-none font-sans ${variants[variant]} ${className}`}
    {...props}
  >
    {icon && <span className="flex items-center">{icon}</span>}
    {children}
  </button>
);
